module.exports = __webpack_public_path__ + "assets/img/btn_more1.88b46a5d.png";